var _path, _circle, _path2, _circle2, _circle3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRoundCartIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 88,
    viewBox: "0 0 64 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.0002 25.1445C27.9553 22.9132 29.7475 21.0462 31.9788 21C31.9931 20.9997 32.0074 20.9997 32.0217 21C34.253 21.0462 36.0452 22.9132 36.0002 25.1445V26.8183L38.7249 26.039C38.8683 25.9979 39.0191 25.9894 39.1663 26.0142C39.3134 26.0389 39.4532 26.0963 39.5753 26.1821C39.6974 26.2678 39.7988 26.3798 39.872 26.5099C39.9452 26.6399 39.9883 26.7847 39.9983 26.9336L40.6709 37.0221C40.1036 36.513 39.3901 36.1637 38.6011 36.0448L38.0842 28.3008L36.0002 28.8965V31C36.0021 31.1325 35.9776 31.2641 35.9282 31.387C35.8788 31.51 35.8055 31.6219 35.7124 31.7163C35.6194 31.8107 35.5085 31.8856 35.3862 31.9367C35.264 31.9879 35.1328 32.0142 35.0002 32.0142C34.8677 32.0142 34.7365 31.9879 34.6143 31.9367C34.492 31.8856 34.3811 31.8107 34.2881 31.7163C34.195 31.6219 34.1217 31.51 34.0723 31.387C34.0229 31.2641 33.9984 31.1325 34.0002 31V29.4687L32.2756 29.9609C32.0957 30.0125 31.9048 30.0125 31.7249 29.9609L30.0002 29.4687V31C30.0021 31.1325 29.9776 31.2641 29.9282 31.387C29.8788 31.51 29.8055 31.6219 29.7124 31.7163C29.6194 31.8107 29.5085 31.8856 29.3862 31.9367C29.264 31.9879 29.1328 32.0142 29.0002 32.0142C28.8677 32.0142 28.7365 31.9879 28.6143 31.9367C28.492 31.8856 28.3811 31.8107 28.2881 31.7163C28.195 31.6219 28.1217 31.51 28.0723 31.387C28.0229 31.2641 27.9984 31.1325 28.0002 31V28.8965L25.9163 28.3008L25.0686 41H34.1263C34.3286 41.7862 34.764 42.4789 35.3544 43H24.0002C23.8633 43 23.7278 42.9719 23.6022 42.9174C23.4766 42.8629 23.3635 42.7833 23.2699 42.6833C23.1763 42.5833 23.1043 42.4652 23.0582 42.3362C23.0122 42.2073 22.9931 42.0702 23.0022 41.9336L24.0022 26.9336C24.0188 26.684 24.1282 26.4498 24.309 26.277C24.4898 26.1041 24.7287 26.0053 24.9788 26C25.0791 25.998 25.1792 26.0112 25.2756 26.039L28.0002 26.8183V25.1445ZM34.0002 25.1055C34.0232 23.963 33.1388 23.0468 32.0002 23.0098C30.8617 23.0468 29.9773 23.963 30.0002 25.1055V25.125V27.3887L32.0002 27.9609L34.0002 27.3887V25.125V25.1055Z",
    fill: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 40,
    r: 3,
    fill: "url(#paint0_linear_557_16202)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 63L32 81",
    stroke: "url(#paint1_linear_557_16202)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 84,
    r: 4,
    fill: "#2400FF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    r: 31.5,
    transform: "matrix(1 0 0 -1 32 32)",
    stroke: "url(#paint2_linear_557_16202)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_557_16202",
    x1: 39.6833,
    y1: 37.4333,
    x2: 34.7333,
    y2: 41.8167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2400FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BC10D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_557_16202",
    x1: 31.5,
    y1: 64.3846,
    x2: 29.6517,
    y2: 64.6501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC10D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2400FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_557_16202",
    x1: 34,
    y1: 64,
    x2: 33.3333,
    y2: 0.66667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2400FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BC10D5"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundCartIcon);
export default __webpack_public_path__ + "static/media/round-cart-icon.e470bc81972916bb51205e93bc0b29ae.svg";
export { ForwardRef as ReactComponent };